<template>
  <div class="headline_box">
    <!-- <iframe id="show-iframe" frameborder="0" name="showHere" scrolling="auto" :src="detailObj.content" @load="loaded"></iframe> -->
    <iframe
      id="show-iframe"
      frameborder="0"
      name="showHere"
      scrolling="auto"
      :src="detailObj.content"
      @load="loaded"
    ></iframe>
    <!-- <x-button class="openYsl" @click="goYsl">打开医生汇，查看更多同行评论</x-button>
        <div class="hasPadding" style="padding-bottom: 2rem">
            <h5 class="pTitle">热点阅读</h5>
            <list-for-img-and-text :list="listData" :ifShare='1'></list-for-img-and-text>
        </div> -->
    <div class="footer" @click="show(1)">
      <swiper
        auto
        height="2.84rem"
        :interval="2000"
        :show-dots="true"
        dots-class="custom-bottom"
        dots-position="center"
      >
        <swiper-item v-for="(item, index) in newList" :key="index">
          <img
            v-if="index == 0"
            src="http://cdn.yxvzb.com/testBuild/qun2/top%20@2x.png"
            class="cover"
          />
          <img :src="item.coverPic" class="swipe_img" />
          <span class="swipe_title">{{ item.title }}</span>
        </swiper-item>
      </swiper>
    </div>
    <div class="qrBox" v-show="showFlag" @touchmove.prevent @click="hide">
      <div class="qrMain"></div>
      <img
        src="//cdn.yxvzb.com/img/dati/dati1014duicuobk_03.png"
        class="qrCode"
      />
      <p>
        关注医学V视界
      </p>
      <p>
        更多精彩随心看
      </p>
    </div>
    <span
      class="focus"
      @click="show(2)"
      style="width: 1rem;height: .59rem;border-radius: .08rem;background: linear-gradient(to right,#2EACFD,#027CFA);text-align: center;line-height:.59rem;color: #fff;display:inline-block"
    >
      关注
    </span>
  </div>
</template>
<script>
import ListForImgAndText from '@/components/Headline/list.vue';
import fan from './components/fan.vue';
import { headline, shareCallback } from '@/api/ajax.js';
// TODO: vux
import {
  Confirm,
  TransferDomDirective as TransferDom,
  XButton,
  Swiper,
  SwiperItem
} from 'vux';
import { mapState, mapActions } from 'vuex';
export default {
  name: '',
  directives: {
    TransferDom
  },
  data() {
    return {
      detailObj: {},
      listData: [],
      showSub: true, //  详情中的订阅
      showToPushInfo: false, // 用户内的订阅
      showBigPushInfo: false, // 订阅大弹层
      agin: false,
      isCollection: false,
      newList: [], // 午间资讯列表
      showFlag: false
    };
  },
  methods: {
    ...mapActions(['wxUserInfoAction']),
    eventCollection(val) {
      this.isCollection = val;
    },
    goYsl() {
      window.location =
        'http://a.app.qq.com/o/simple.jsp?pkgname=com.yxvzb.app';
    },
    show(type) {
      scrollTo(0, 0);
      this.showFlag = true;
      if (type == 1) {
        sa.track('wx_fenxiangye_zixuntuijian', {}, function() {});
      } else if (type == 2) {
        sa.track('wx_fenxiangye_zixunguanzhu', {}, function() {});
      }
    },
    hide() {
      this.showFlag = false;
    },
    getDetail() {
      let data = {
        id: this.$route.params.id,
        type: this.$route.query.type
      };
      headline.detail(data).then(res => {
        this.detailObj = res.data.data;
        this.detailObj.type != 2
          ? (this.showBigPushInfo = true)
          : (this.showBigPushInfo = false);
        this.listData = res.data.data.relationNews;
        this.isCollection = res.data.data.collection;
        if (this.detailObj.subCategory) {
          this.showSub = false;
        }
        let wxUserInfo = this.$api.getStorage('wxUserInfo');
        let shareFlag = 'wx';
        if (/shareFlag/.test(location.href)) {
          shareFlag = 'share';
        }
        sa.track(
          'caseDetail',
          {
            title: this.detailObj.title,
            type: 'information',
            pageUrl: location.href,
            from: shareFlag,
            //            editor:'<s:property value="qaDetail.information.editor"></s:property>',
            client_id: wxUserInfo.id || wxUserInfo.wxOpenId,
            distinctId: wxUserInfo.id || wxUserInfo.wxOpenId,
            web_edition: 2
          },
          function() {}
        );
        let oIframe = document.getElementById('show-iframe');
        let deviceWidth = document.documentElement.clientWidth;
        let deviceHeight = document.documentElement.clientHeight;
        oIframe.style.width = deviceWidth + 'px';
        oIframe.style.height = deviceHeight + 'px';
        //          oIframe.style.height = oIframe.contentDocument.body.scrollHeight+'px'
        /*
         * 分享
         * */
        let shareCallBackFunc = () => {
          shareCallback().then(res => {
            if (res.data.status != '0') {
              // 恭喜您分享成功,获得3积分 每天前5次分享均可获得3积分
              this.$vux.toast.show({
                text: '恭喜您获得3积分',
                type: 'success',
                width: '5rem'
              });
            } else {
              // 您已获得今天全部分享 积分每天前5次分享均可获得3积分
              this.$vux.toast.show({
                text: '分享成功!',
                type: 'success',
                width: '5rem'
              });
            }
            let wxUserInfo = this.$api.getStorage('wxUserInfo');
            sa.track(
              'share_total',
              {
                from: 'wx',
                type: 'information',
                target: this.$route.params.id,
                client_id: wxUserInfo.id || wxUserInfo.wxOpenId,
                web_edition: 2
              },
              function() {}
            );
          });
        };
        this.$wxShareInfo(
          this.detailObj.title,
          this.detailObj.shareDesc,
          this.detailObj.sharePic,
          location.href,
          location.href + '&shareFlag=true',
          shareCallBackFunc
        );
      });
    },
    fetchData() {
      location.reload();
      //        let oIframe = document.getElementById('show-iframe');
      //        let deviceWidth = document.documentElement.clientWidth;
      //        let deviceHeight = document.documentElement.clientHeight;
      //        oIframe.style.width = deviceWidth + 'px';
      //        oIframe.style.height = deviceHeight + 'px';
      //        this.getDetail()
    },
    subInformationRelationDepartment() {
      // 订阅按钮
      headline
        .subInformationRelationDepartment({
          id: this.$route.params.id
        })
        .then(res => {
          this.showSub = false;
          this.$vux.toast.show({
            text: '订阅成功',
            type: 'success',
            width: '5rem'
          });
        });
    },
    toPushInfo() {
      // 浮层订阅
      headline
        .toPushInfo({
          userId: this.wxUserInfo.id,
          status: this.agin ? 0 : 1
        })
        .then(res => {
          this.showToPushInfo = false;
          this.wxUserInfoAction(
            Object.assign(this.$api.getStorage('wxUserInfo'), {
              isRecieveInfoPush: 1
            })
          );
        });
    },
    onCancel() {
      this.showToPushInfo = false;
      if (this.agin) {
        headline
          .toPushInfo({
            userId: this.wxUserInfo.id,
            status: this.agin ? 0 : 1
          })
          .then(res => {
            this.wxUserInfoAction(
              Object.assign(this.$api.getStorage('wxUserInfo'), {
                isRecieveInfoPush: 1
              })
            );
          });
      }
    },
    loaded() {
      try {
        if (this.$api.kernel() == 'wx') {
          document
            .getElementById('show-iframe')
            .contentWindow.document.querySelector(
              '.topWxLoad'
            ).onclick = function() {
            window.location.href =
              'http://www.yxvzb.com/download?qudao=beiyong1';
          };
        }
        let oIframe = document.getElementById('show-iframe');
        oIframe.contentDocument.body.style.width = '9rem';
        oIframe.contentDocument.body.style.margin = 'auth';
        oIframe.style.height =
          Math.max(
            oIframe.contentDocument.body.clientHeight,
            oIframe.contentDocument.body.scrollHeight,
            oIframe.contentDocument.body.scrollTop,
            oIframe.contentWindow.document.documentElement.scrollHeight
          ) + 'px';
      } catch (e) {
        console.log('cuowu');
      }
      let oIframe = document.getElementById('show-iframe').contentWindow;
      // console.log(oIframe)
      let top = oIframe.document.getElementsByClassName('topProvenance')[0];
      // console.log(top)
      let node = document.getElementsByClassName('focus')[0];
      top.appendChild(node);
    }
  },
  computed: {
    ...mapState({
      wxUserInfo: state => state.wxUserInfo
    })
  },
  components: {
    ListForImgAndText,
    Confirm,
    XButton,
    Swiper,
    SwiperItem,
    fan
  },
  watch: {
    $route: 'fetchData',
    wxUserInfo(val) {
      val.isRecieveInfoPush == 1
        ? (this.showToPushInfo = false)
        : (this.showToPushInfo = true);
    }
  },
  created() {
    headline.getShare({}).then(res => {
      this.newList = res.data.data;
    });
    if (this.$api.getStorage('wxUserInfo')) {
      let userDataStatus =
        this.$api.getStorage('wxUserInfo').userDataStatus || '';
      if (userDataStatus) {
        this.$router.push({
          name: 'headLineDetail',
          query: {
            courseId: this.$route.query.courseId
          }
        });
      }
    }
  },
  mounted() {
    this.wxUserInfo.isRecieveInfoPush == 1
      ? (this.showToPushInfo = false)
      : (this.showToPushInfo = true);
    this.getDetail();
    // setTimeout(function(){
    //   console.log(1111)
    //   let oIframe = document.getElementById('show-iframe').contentWindow
    //   console.log(oIframe)
    //   let top = oIframe.document.getElementsByClassName('topProvenance')[0]
    //   console.log(top)
    //   let node = document.getElementsByClassName('focus')[0]
    //   top.appendChild(node)
    // },2000)
  }
};
</script>
<style lang="less">
.footer {
  .vux-slider > .vux-indicator,
  .vux-slider .vux-indicator-right {
    bottom: 1.25rem !important;
  }
  .vux-icon-dot.active {
    background: #027cfa !important;
    width: 0.29rem !important;
    height: 0.2rem !important;
    border-radius: 0.1rem !important;
  }
}
</style>
<style scoped lang="less">
.focus {
  width: 1.44rem;
  height: 0.59rem;
  border-radius: 0.08rem;
  background: linear-gradient(to right, #2eacfd, #027cfa);
  margin-left: 0.4rem;
  text-align: center;
  line-height: 0.59rem;
  color: #fff;
}
.openYsl {
  width: 9.2rem;
  height: 1.04rem;
  margin: 0.4rem auto;
  background: #027cfa;
  border-radius: 3px;
  font-size: 0.4rem;
  color: #ffffff;
  line-height: 1.6rem;
}
.pTitle {
  font-size: 0.3733rem;
}
.notPrompt {
}
.headline_box {
  width: 100%;
  .weui-btn_primary {
    background-color: #027cfa;
    padding: 0.2rem 0;
    margin: 0.2rem 0;
  }
}
.qrBox {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  .qrMain {
    width: 7.87rem;
    height: 9.68rem;
    margin: 0 auto;
    margin-top: 1.47rem;
    height: 100%;
    background: url('http://cdn.yxvzb.com/testBuild/qun2/%E5%BC%B9%E5%B1%82-%E5%BA%95@2x.png')
      no-repeat;
    background-size: contain;
  }
  .qrCode {
    width: 3.95rem;
    height: 3.95rem;
    position: absolute;
    top: 4.83rem;
    left: 3.03rem;
  }
  p:first-of-type {
    font-size: 0.45rem;
    color: #027cfa;
    line-height: 1;
    position: absolute;
    top: 9.3rem;
    text-align: center;
    width: 100%;
  }
  p:last-of-type {
    position: absolute;
    top: 10.2rem;
    font-size: 0.4rem;
    color: #161616;
    text-align: center;
    width: 100%;
    line-height: 1;
  }
}
.footer {
  position: fixed;
  bottom: 0;
  height: 1.71rem;
  width: 100%;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
  padding-left: 0.4rem;
  padding-top: 0.13rem;
  padding-right: 0.4rem;
  background: #fff;
  .cover {
    position: absolute;
    left: 0;
    top: 0;
    width: 1.07rem;
    height: 1.07rem;
  }
  .swipe_img {
    width: 2.16rem;
    height: 1.44rem;
    float: left;
    margin-right: 0.27rem;
  }
  .swipe_title {
    float: left;
    font-size: 0.37rem;
    color: #191919;
    width: 6.77rem;
  }
}
</style>
